import {alpha} from "@mui/material/styles";

export default function Lists(theme: any) {
	return {
		MuiMenuItem: {
			styleOverrides: {
				root: {
					//background: 'transparent',
					'&.Mui-selected': { // <-- mixing the two classes
						backgroundColor: alpha(theme.palette.secondary.light, 0.5),
					}
				}
			}
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					color: 'inherit',
					minWidth: 'auto',
					marginRight: theme.spacing(2),
				},
			},
		},
		MuiListItemAvatar: {
			styleOverrides: {
				root: {
					minWidth: 'auto',
					marginRight: theme.spacing(2),
				},
			},
		},
		MuiListItemText: {
			styleOverrides: {
				root: {
					marginTop: 0,
					marginBottom: 0,
				},
				multiline: {
					marginTop: 0,
					marginBottom: 0,
				},
			},
		},
	};
}
